import { render, staticRenderFns } from "./VideoCourse.vue?vue&type=template&id=2f2b0087&scoped=true"
import script from "./VideoCourse.vue?vue&type=script&lang=js"
export * from "./VideoCourse.vue?vue&type=script&lang=js"
import style0 from "./VideoCourse.vue?vue&type=style&index=0&id=2f2b0087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b0087",
  null
  
)

export default component.exports